var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 2.84658C15.9999 3.07107 15.9062 3.2865 15.7395 3.4452C15.5729 3.6039 15.3467 3.69312 15.111 3.69312H12.0592V13.0053C12.0592 13.3078 11.8897 13.5872 11.6147 13.7385C11.3397 13.8896 11.0008 13.8896 10.7258 13.7385C10.4508 13.5872 10.2814 13.3078 10.2814 13.0053V3.69312H7.22362C6.90603 3.69312 6.61264 3.53175 6.45393 3.26984C6.29507 3.00794 6.29507 2.68518 6.45393 2.42328C6.61266 2.16138 6.90606 2 7.22362 2H15.1111C15.3468 2 15.573 2.08919 15.7397 2.24792C15.9063 2.40665 16 2.62209 16 2.84654L15.9999 2.84658ZM5.92587 6.51501H0.888869C0.571279 6.51501 0.277894 6.67638 0.119047 6.93829C-0.0396822 7.20019 -0.0396822 7.52294 0.119047 7.78485C0.277908 8.04675 0.571276 8.20813 0.888869 8.20813H2.52445V13.0053C2.52445 13.3078 2.69389 13.5872 2.96889 13.7385C3.24388 13.8896 3.58277 13.8896 3.85777 13.7385C4.13277 13.5872 4.30221 13.3078 4.30221 13.0053V8.20813H5.93183C6.24942 8.20813 6.5428 8.04675 6.70151 7.78485C6.86038 7.52294 6.86038 7.20019 6.70151 6.93829C6.54279 6.67638 6.24939 6.51501 5.93183 6.51501H5.92587Z",
    fill: "#8F96A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextCategoryIcon);
export default __webpack_public_path__ + "static/media/text-category-icon.f6b7583347b6404ba53fd53df13b8bfb.svg";
export { ForwardRef as ReactComponent };